// @ts-nocheck
import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import { getToken } from '@/utils/token/index'
import { useUserInfoStore } from '@/stores/user-info'
import { message } from 'ant-design-vue'

import { useLogout } from '@/components/logout/hook'
import Layout from '@/views/layout/index.vue'
const router = createRouter({
    history: createWebHistory(),
    routes: [
        // {
        //   path: '/',
        //   redirect: '/index'
        // },
        // {
        //   path: '/',
        //   name: 'gongce',
        //   component: () => import('@/views/gongce/index.vue')
        // },
        {
            path: '/',
            name: 'index',
            component: Layout,
            redirect: '/square',
            meta: {
                name: '营赛洞见',
                title: '营赛洞见'
            },
            children: [
                {
                    path: '/square',
                    name: 'square',
                    // redirect: '/chat', // 安全
                    meta: {
                        name: '灵感广场',
                        title: '灵感广场',
                        keepAlive: true
                    },
                    component: () => import('@/views/square/index.vue')
                },
                {
                    path: '/chat',
                    name: 'chat',
                    meta: {
                        name: '创作空间',
                        title: '创作空间'
                    },
                    component: () => import('@/views/chat/index.vue')
                },
                {
                    path: '/preview',
                    name: 'preview',
                    component: () => import('@/views/preview/index.vue')
                },
                {
                    path: '/tab/:tabName',
                    component: () => import('@/views/square/index.vue'),
                    props: { scrollTo: 'navbar' }
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/account/login/index.vue')
        },
        {
            path: '/policy',
            name: 'policy',
            component: () => import('@/views/user-agreetment/index.vue')
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: () => import('@/views/user-privacy/index.vue')
        },
        {
            path: '/mpolicy',
            name: 'mpolicy',
            component: () => import('@/views-h5/user-agreetment/index.vue')
        },
        {
            path: '/mprivacy',
            name: 'mprivacy',
            component: () => import('@/views-h5/user-privacy/index.vue')
        },
        {
            path: '/markdown',
            name: 'markdown',
            component: () => import('@/views/test/test-markdown.vue')
        },
        {
            path: '/test',
            name: 'test',
            component: () => import('@/views/test/typetext.vue')
        }
    ]
})

export default router

export const routerGuard = () => {
    const whiteList = ['/policy', '/login', '/privacy'] // 没有重定向白名单
    const userStore = useUserInfoStore()
    const { handleLogout } = useLogout()

    router.beforeEach(async (to, from, next) => {
        // 判断用户是否登录
        const hasToken = getToken()
        if (hasToken) {
            if (!userStore.userInfo?.id) {
                try {
                    await userStore.initUserInfo()
                } catch (error) {
                    console.log('用户信息获取异常', error, to)
                    message.warn('用户信息获取异常, 请重新登录！')
                    handleLogout()
                    return
                }
            }
            next()
        } else {
            next()
        }
    })
}
